import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'd2d-notification-template',
  standalone: true,
  imports: [CommonModule, ToastModule],
  templateUrl: './notification-template.component.html',
})
export class NotificationTemplateComponent {}
